import * as React from "react";
import { Translation } from "react-i18next";
import _capitalize from 'lodash/capitalize';
import { isNil } from "lodash";
import { RestaurantUtils } from "@lib/common";
import { ListWrapper, ListSection, List, ListTitle, ListItem, ListItemHighlight } from "../list/index";
const RegularOptionSetRenderer = (props) => {
    const { isPrinting, isBumpScreen, dishQty } = props;
    const optionSet = props.optionSet;
    const freeQty = optionSet.conditions.free_amount || 0;
    const options = optionSet.options && Array.isArray(optionSet.options) ? optionSet.options.filter(option => option.quantity > 0) : [];
    if (options.length === 0) {
        return null;
    }
    return (React.createElement(Translation, null, (t) => (React.createElement(ListSection, null,
        (isPrinting && optionSet.print_hide_option_set_name) || (isBumpScreen && (optionSet.print_hide_option_set_name === undefined || optionSet.print_hide_option_set_name === true)) ?
            null : React.createElement(ListTitle, null, optionSet.display_name || optionSet.name),
        React.createElement(List, null, options.map((option) => {
            if (props.renderDetails.option_prices) {
                const price = RestaurantUtils.dish.calculateOptionSetOptionPrice(option, optionSet, props.optionSets);
                if (option.quantity === 1) {
                    return (React.createElement(ListItem, { key: option._id, className: "r-list-item" },
                        ((isPrinting && option.print_name) || (isBumpScreen && option.print_name)) ? option.print_name : option.name,
                        (price && !freeQty) ? React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                            "+",
                            t("currency", { value: price }),
                            " x ",
                            dishQty || 1) : ""));
                }
                return (React.createElement(ListItem, { key: option._id, className: "r-list-item" },
                    ((isPrinting && option.print_name) || (isBumpScreen && option.print_name)) ? option.print_name : option.name,
                    (price && !freeQty) ? (React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                        "+",
                        t("currency", { value: price }),
                        " x ",
                        option.quantity)) : (React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                        " x ",
                        option.quantity))));
            }
            if (option.quantity === 1) {
                return React.createElement(ListItem, { key: option._id, className: "r-list-item" }, ((isPrinting && option.print_name) || (isBumpScreen && option.print_name)) ? option.print_name : option.name);
            }
            return (React.createElement(ListItem, { key: option._id, className: "r-list-item" },
                ((isPrinting && option.print_name) || (isBumpScreen && option.print_name)) ? option.print_name : option.name,
                " ",
                React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                    " x ",
                    option.quantity)));
        }))))));
};
const OptionSetWithPointsRenderer = (props) => {
    const { isPrinting, isBumpScreen, dishQty } = props;
    const optionSet = props.optionSet;
    const options = RestaurantUtils.dish.groupOptionSetOptionByPosition(optionSet);
    if (Object.keys(options).length === 0) {
        return null;
    }
    return (React.createElement(Translation, null, (t) => (React.createElement(React.Fragment, null, Object.keys(options).map(key => {
        return (React.createElement(ListSection, { key: key },
            (isPrinting && optionSet.print_hide_option_set_name) || (isBumpScreen && (optionSet.print_hide_option_set_name === undefined || optionSet.print_hide_option_set_name === true)) ?
                null : React.createElement(ListTitle, null,
                (isNil(key) || key === 'undefined') ? '' : _capitalize(key) + ':',
                " ",
                optionSet.display_name || optionSet.name),
            React.createElement(List, null, options[key].map(option => {
                const quantityMultiplier = RestaurantUtils.dish.getOptionSetOptionDisplayingQuantityMultiplier(option);
                if (props.renderDetails.option_prices) {
                    const price = RestaurantUtils.dish.calculateOptionSetOptionPrice(option, optionSet, props.optionSets);
                    return (React.createElement(ListItem, { key: option._id, className: "r-list-item" },
                        ((isPrinting && option.print_name) || (isBumpScreen && option.print_name)) ? option.print_name : option.name,
                        quantityMultiplier && React.createElement(ListItemHighlight, { className: "list-item-highlight" }, quantityMultiplier),
                        (price) ? React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                            "+",
                            t("currency", { value: price }),
                            " x ",
                            dishQty || 1) : ""));
                }
                return (React.createElement(ListItem, { key: option._id, className: "r-list-item" },
                    ((isPrinting && option.print_name) || (isBumpScreen && option.print_name)) ? option.print_name : option.name,
                    quantityMultiplier && React.createElement(ListItemHighlight, { className: "list-item-highlight" }, quantityMultiplier)));
            }))));
    })))));
};
class DishOptionSetListClass extends React.Component {
    render() {
        const { option_sets, renderDetails, isPrinting, isBumpScreen, dishQty } = this.props;
        return (React.createElement(ListWrapper, null, option_sets.map((optionSet) => {
            if (optionSet.using_points) {
                return (React.createElement(OptionSetWithPointsRenderer, { key: optionSet._id, optionSet: optionSet, optionSets: option_sets, renderDetails: renderDetails, isPrinting: isPrinting, isBumpScreen: isBumpScreen, dishQty: dishQty }));
            }
            return (React.createElement(RegularOptionSetRenderer, { key: optionSet._id, optionSet: optionSet, optionSets: option_sets, renderDetails: renderDetails, isPrinting: isPrinting, isBumpScreen: isBumpScreen, dishQty: dishQty }));
        })));
    }
}
export const DishOptionSetList = (DishOptionSetListClass);
//# sourceMappingURL=index.js.map